/**
 * Owner-lane writes that name or retire a registered thing.
 *
 * All three go through `/api/cmmd/*` with the signed-in person's own session;
 * none of them is reachable with a runtime grant. They sit apart from the
 * client class because that class is already past the size where a new method
 * can be read in context.
 */
import type { CmmdDeviceRegistryDevice } from "@cmmd-forge/contracts";
import type { CmmdRenamedForgeCloudEnvironment } from "../primary/cloudProjectCatalog";
import { request, type TransportConfig } from "./transport";

/**
 * Name the caller's cloud Environment; `null` clears it back to derived.
 *
 * Rejects with `CmmdApiError` carrying `code: "environment_name_taken"` when
 * this Seat already has an Environment by that name.
 */
export function renameCloudEnvironment(
  cfg: TransportConfig,
  runtimeId: string,
  displayName: string | null,
): Promise<CmmdRenamedForgeCloudEnvironment> {
  return request<CmmdRenamedForgeCloudEnvironment>(
    {
      method: "POST",
      path: `/api/cmmd/forge-runtimes/${encodeURIComponent(runtimeId)}/rename`,
      body: { displayName },
    },
    cfg,
  );
}

export function renameDevice(
  cfg: TransportConfig,
  deviceId: number,
  displayName: string,
): Promise<CmmdDeviceRegistryDevice> {
  return request<CmmdDeviceRegistryDevice>(
    {
      method: "POST",
      path: `/api/cmmd/devices/${encodeURIComponent(String(deviceId))}/rename`,
      body: { displayName },
    },
    cfg,
  );
}

export function revokeDevice(
  cfg: TransportConfig,
  deviceId: number,
): Promise<CmmdDeviceRegistryDevice> {
  return request<CmmdDeviceRegistryDevice>(
    { method: "POST", path: `/api/cmmd/devices/${encodeURIComponent(String(deviceId))}/revoke` },
    cfg,
  );
}
